import { isNil } from 'lodash'
import { EntityWithChanges } from '../../models/entities-with-changes/entity-with-changes.type'

export function getCrFieldToDisplay<T>(
  fieldName: string,
  element: EntityWithChanges<T>,
  defaultValue: number | string = element[fieldName]
) {
  return !isNil(element?.changes?.[fieldName]) ? element?.changes?.[fieldName]?.new : defaultValue
}
